function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#5B6572",
  fillRule: "nonzero",
  stroke: "#5B6572",
  strokeWidth: .1,
  d: "M23.86 2.418h-1.536V1.89a.455.455 0 0 0-.325-.454 12.654 12.654 0 0 0-3.258-.419c-1.808 0-4.27.41-6.092 2.274-1.807-1.883-4.288-2.274-6.09-2.274-1.1-.002-2.195.138-3.259.419a.455.455 0 0 0-.325.454v.523H1.452A.453.453 0 0 0 1 2.868v14.525a.453.453 0 0 0 .673.395c.045-.022 4.564-2.51 10.872-.91H12.653a.45.45 0 0 0 .11 0c6.326-1.614 10.844.87 10.871.91a.45.45 0 0 0 .452 0 .455.455 0 0 0 .226-.39V2.872a.453.453 0 0 0-.452-.455zM1.904 16.67V3.327h1.08v11.405a.453.453 0 0 0 .52.455c.934-.144 1.878-.22 2.824-.227 1.31-.023 2.614.175 3.859.586a16.516 16.516 0 0 0-8.283 1.124zm4.424-2.615c-.822.002-1.643.055-2.459.159V2.25c.88-.198 1.779-.298 2.68-.3 1.69 0 4.022.39 5.64 2.228l.013 11.327c-.94-.618-2.775-1.45-5.874-1.45zm6.778-9.877c1.617-1.82 3.95-2.228 5.64-2.228.9.002 1.799.103 2.679.3v11.964c-.811-.105-1.627-.16-2.445-.164-3.082 0-4.92.832-5.874 1.45V4.179zM23.404 16.67a16.52 16.52 0 0 0-8.301-1.124 11.681 11.681 0 0 1 3.877-.586c.952.005 1.901.08 2.842.223a.452.452 0 0 0 .52-.455v-11.4h1.08l-.018 13.342z"
});

const SvgComponent = props => React.createElement("svg", _extends({
  width: 25,
  height: 18,
  viewBox: "0 0 25 18"
}, props), _ref);

export default __webpack_public_path__ + "static/media/ig-stories-filter.6fc0e05c.svg";
export { SvgComponent as ReactComponent };